module.exports = __webpack_public_path__ + "assets/clever-insights-weclever-logo-component.0c082017.svg";